import React, {useEffect} from "react";
import * as Markdown from 'react-markdown';
import { useStaticQuery, graphql } from "gatsby";

const TextBlock = ({ displayWidth, slug }) => {

    const textBlockQuery = useStaticQuery(graphql`
      query textBlockQuery {
        allContentfulTextBlock {
            edges {
              node {
                content {
                  childMarkdownRemark {
                    rawMarkdownBody
                    html
                  }
                }
                slug
              }
            }
          }
      }
    `)
    const data = textBlockQuery.allContentfulTextBlock.edges.find(d => d.node.slug === slug)

    useEffect(
        () => {
            const a = document.querySelectorAll('TABLE')
            for (let val of Object.values(a)) {
                val.classList.add('uk-table', 'uk-table-striped', 'uk-table-middle')
            }
        }, []
    )

    return (
        <section id={slug} className="uk-section uk-section-small">
            <div className={`uk-container uk-container-${displayWidth}`}>
              <div className={`uk-container`}>
                <Markdown
                    source={data.node.content.childMarkdownRemark.html}
                    escapeHtml={false}
                />
                </div>
            </div>
        </section>
    );
}

export default TextBlock;
